import { Activity } from 'lucide-react';
import styles from './CaloriesPage.module.css';

const IOS_APP_URL = 'https://apps.apple.com/us/app/peapil-health/id6748030177';
const ANDROID_APP_URL = 'https://play.google.com/store/apps/details?id=com.peapilpublishing.app';

export default function CaloriesPage() {
  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <h1 className={styles.title}>
          <Activity size={28} />
          Calorie Tracker
        </h1>
        <p className={styles.subtitle}>Track your daily food intake with AI-powered photo analysis</p>
      </header>

      <div className={styles.content}>
        <div className={styles.featureCard}>
          <div className={styles.featureLayout}>
            <div className={styles.phoneImageWrapper}>
              <img 
                src="/app-screenshot-calories.png" 
                alt="Peapil Health Calorie Tracker" 
                className={styles.phoneImage}
              />
            </div>
            <div className={styles.featureText}>
              <h3 className={styles.downloadTitle}>Download the Peapil Health App</h3>
              <p className={styles.featureDescription}>
                Our calorie tracking feature uses your phone's camera to instantly analyze 
                your meals and estimate calories, protein, carbs, and fat. This feature 
                requires camera access, which is only available on our mobile app.
              </p>
              <div className={styles.appLinks}>
                <a href={IOS_APP_URL} target="_blank" rel="noopener noreferrer" className={styles.storeBadgeLink}>
                  <img src="/app-store-badge-black.avif" alt="Download on the App Store" className={styles.storeBadge} />
                </a>

                <a href={ANDROID_APP_URL} target="_blank" rel="noopener noreferrer" className={styles.storeBadgeLink}>
                  <img src="/play-store-badge-black.avif" alt="Get it on Google Play" className={styles.storeBadge} />
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.featuresList}>
          <h3 className={styles.featuresTitle}>Mobile App Features</h3>
          <ul className={styles.features}>
            <li>Take a photo of any meal for instant calorie estimation</li>
            <li>Track daily calorie intake with progress charts</li>
            <li>Set personalized calorie goals based on your health profile</li>
            <li>View macro breakdown (protein, carbs, fat)</li>
            <li>Browse 30 days of calorie history</li>
            <li>Manual food entry for packaged items</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
